import axios from 'axios';

export const requestLanguages = () => axios.get('https://interpretator.com/references/languages.json');

export default requestLanguages;
